import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyCLGhougkiHsApHw5rlHLmxD0fd4yH-g7k",
    authDomain: "portfolio-web-3d847.firebaseapp.com",
    projectId: "portfolio-web-3d847",
    storageBucket: "portfolio-web-3d847.appspot.com",
    messagingSenderId: "799688623858",
    appId: "1:799688623858:web:d47b9c817f1a2b695bf26b"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;